/**
 * Body mohou být desetinné (stanoviště vysílaček má třeba 3,5), takže se
 * formátují s desetinnou čárkou a bez zbytečných nul — stejně jako v mobilní
 * aplikaci (mobile/src/theme/walkie.ts).
 */
export function formatPoints(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded).replace('.', ',');
}

/** "1 bod", "3 body", "7 bodů", "3,5 bodu" — desetinné číslo bere genitiv. */
export function formatPointsWithUnit(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  const formatted = formatPoints(rounded);
  if (!Number.isInteger(rounded)) return `${formatted} bodu`;
  if (rounded === 1) return `${formatted} bod`;
  if (rounded >= 2 && rounded <= 4) return `${formatted} body`;
  return `${formatted} bodů`;
}

/** Milisekundy na MM:SS — stopky měří v řádu minut. */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** Sekundy na "12 min" / "1,5 min" — interval kola jde zadat i desetinný. */
export function formatIntervalMinutes(seconds: number): string {
  const rounded = Math.round((seconds / 60) * 100) / 100;
  return Number.isInteger(rounded)
    ? `${rounded} min`
    : `${String(rounded).replace('.', ',')} min`;
}

/**
 * Odpočet kola. Nad hodinu přidává hodiny — hra může stát bez nového kola dlouho
 * a "546:46" se pak nedá přečíst.
 */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const seconds = String(total % 60).padStart(2, '0');
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes}:${seconds}`;
  const hours = Math.floor(minutes / 60);
  return `${hours}:${String(minutes % 60).padStart(2, '0')}:${seconds}`;
}

/** "27 členů" — čeština potřebuje tři tvary. */
export function plural(n: number, one: string, few: string, many: string): string {
  if (n === 1) return `${n} ${one}`;
  if (n >= 2 && n <= 4) return `${n} ${few}`;
  return `${n} ${many}`;
}
